import BusinessIcon from "@mui/icons-material/Business";
import PolicyIcon from "@mui/icons-material/Policy";
import GroupIcon from "@mui/icons-material/Group";
import { FilterList, FilterListItem, FilterLiveSearch, SavedQueriesList } from "react-admin";
import { StyledListAside } from "@/components/ui/react-admin/StyledListAside";
import { ClientStatus } from "@/types";

export const ClientListAside = () => {
  return (
    <StyledListAside>
      <FilterLiveSearch />
      <SavedQueriesList />

      {/* Client Status Filter */}
      <FilterList label="Client Status" icon={<BusinessIcon />}>
        <FilterListItem
          label="Building"
          value={{
            client_status: ClientStatus.BUILDING,
          }}
        />
        <FilterListItem
          label="Approved"
          value={{
            client_status: ClientStatus.APPROVED,
          }}
        />
        <FilterListItem
          label="Active"
          value={{
            client_status: ClientStatus.ACTIVE,
          }}
        />
        <FilterListItem
          label="Inactive"
          value={{
            client_status: ClientStatus.INACTIVE,
          }}
        />
        <FilterListItem
          label="Paused"
          value={{
            client_status: ClientStatus.PAUSED,
          }}
        />
      </FilterList>

      {/* Policy Status Filter */}
      <FilterList label="Policy Status" icon={<PolicyIcon />}>
        <FilterListItem
          label="Has Active Policy"
          value={{
            has_active_policy: true,
          }}
        />
        <FilterListItem
          label="No Active Policy"
          value={{
            has_active_policy: false,
          }}
        />
      </FilterList>

      {/* Corporate Structure Filter */}
      <FilterList label="Corporate Structure" icon={<GroupIcon />}>
        <FilterListItem
          label="Has Child Companies"
          value={{
            has_children_co: true,
          }}
        />
        <FilterListItem
          label="No Child Companies"
          value={{
            has_children_co: false,
          }}
        />
      </FilterList>
    </StyledListAside>
  );
};
